module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-4-b16d0a0c32e8bb0818483882a50fb9e7.svg";